var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money-bag-icon",
    d: "M3.619,18A3.855,3.855,0,0,1,.456,16.312a3.351,3.351,0,0,1,0-3.375l4.016-6.75a1.3,1.3,0,0,1,1.1-.563h4.866a1.3,1.3,0,0,1,1.1.563l4.016,6.75a3.344,3.344,0,0,1,0,3.375A3.855,3.855,0,0,1,12.38,18ZM5.566,3.375a1.15,1.15,0,0,1-.852-.337L3.5,1.913A1.1,1.1,0,0,1,4.35,0h7.3A1.116,1.116,0,0,1,12.5,1.913L11.285,3.037a1.148,1.148,0,0,1-.852.337Z",
    fill: "#bcbccb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagIcon);
export default __webpack_public_path__ + "static/media/money-bag-icon.78c9f49dd2b65ccaaac5ad3e1917d4a3.svg";
export { ForwardRef as ReactComponent };